import React from 'react'
import { Link } from 'react-router-dom'

import AddIcon from 'Assets/Images/icons/add'

export const LinkAddUnstyled = props => (
  <div className={props.className} onClick={props.onClickHandler}>
    <AddIcon />
    <Link to={props.to || ''} />
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/LinkAdd/unstyled.js